import ISO_COUNTRY_CODES from '@data/constants/isoCountryCodes'
import { oneOfString } from '@data/schemas/util/messages'
import { StringSchema, string } from 'yup'

const schema: StringSchema<TIsoCountryAlpha2Code> = string<TIsoCountryAlpha2Code>()
    .oneOf(ISO_COUNTRY_CODES, oneOfString)
    .required()

export default schema
